import { render, staticRenderFns } from "./AffiliateCard.vue?vue&type=template&id=120083ad&"
import script from "./AffiliateCard.vue?vue&type=script&lang=js&"
export * from "./AffiliateCard.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateCard.vue?vue&type=style&index=0&id=120083ad&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports